import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueRouter from 'vue-router';
import VueCookies from 'vue-cookies';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueScrollmagic from 'vue-scrollmagic';

import App from './App.vue';
import store from './store/store';
import messages from './i18n';
import routes from './routes';

/* import of global components */
import ButtonCTA from '@/components/ButtonCTA.vue';

Vue.component('ButtonCTA', ButtonCTA);

Vue.config.productionTip = false;

Vue.use(VueRouter);

Vue.use(VueI18n);

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    // // If you want to set the version, you can do so:
    // v: '3.26',
  },

  // // If you intend to programmatically custom event listener code
  // // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // // you might need to turn this on.
  // autobindAllEvents: false,

  // // If you want to manually install components, e.g.
  // // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  // // Vue.component('GmapMarker', GmapMarker)
  // // then disable the following:
  // installComponents: true,
});

Vue.use(VueScrollmagic);

const router = new VueRouter({
  mode: 'history',
  routes, // short for `routes: routes`
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
});
App.i18n = i18n;

const allowedLocales = ['en', 'cn', 'vn'];
const loadedLanguages = ['en'];

function setI18nLanguage(lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

function loadLanguageAsync(lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(`./i18n/${lang}`)
        .then((msgs) => {
          i18n.setLocaleMessage(lang, msgs.default);
          loadedLanguages.push(lang);
          return setI18nLanguage(lang);
        })
        .catch(() => setI18nLanguage('en'));
    }
    return Promise.resolve(setI18nLanguage(lang));
  }
  return Promise.resolve(lang);
}

router.beforeEach(async (to, from, next) => {
  const {
    params: { locale = 'en' },
    fullPath: toFullPath,
  } = to;
  const {
    params: { locale: fromLocale },
  } = from;

  // hide Menu
  store.commit('hideMenu');

  if (typeof fromLocale === 'undefined') {
    if (allowedLocales.indexOf(locale) !== -1) {
      VueCookies.set('nf_lang', locale);
    } else {
      VueCookies.set('nf_lang', 'en');
    }
  }
  const cookieLang = VueCookies.get('nf_lang');
  await loadLanguageAsync(cookieLang);

  const toFullPathHasLocale = toFullPath.split('/')[1].split('?')[0] === cookieLang;
  if (toFullPathHasLocale) {
    next();
  } else {
    next(`/${cookieLang}${toFullPath}`);
  }
});

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
